import React, { useRef, ChangeEvent } from 'react';
import styles from './photo-upload.module.css';
import Loader from '../loader/loader';
import { useUploadProfilePhotoMutation } from '../../services/store/api/userApi';

interface PhotoUploadProps {
  index?: number;
  className?: string;
}

const PhotoUpload: React.FC<PhotoUploadProps> = ({ index, className }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const [
    uploadProfilePhoto,
    { isLoading, error },
  ] = useUploadProfilePhotoMutation();

  const handleFileSelect = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file || !file.type.startsWith('image/')) return;

    const formData = new FormData();
    formData.append('photo', file);

    try {
      await uploadProfilePhoto(formData).unwrap();
      // success — профиль обновится сам через invalidateTags
    } catch {
      // ошибка обработается ниже
    } finally {
      // чтобы можно было выбрать тот же файл повторно
      event.target.value = '';
    }
  };

  const handleAreaClick = () => {
    if (!isLoading) {
      fileInputRef.current?.click();
    }
  };

  const renderError = () => {
    if (!error || typeof error !== 'object') return null;

    if ('data' in error && typeof error.data === 'object') {
      return (error.data as any).message;
    }

    return 'Ошибка загрузки фото';
  };

  return (
    <div className={`${styles.photoUpload} ${className ?? ''}`}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelect}
        accept="image/*"
        className={styles.fileInput}
        disabled={isLoading}
      />

      <div
        className={styles.uploadArea}
        onClick={handleAreaClick}
      >
        {isLoading ? <Loader tpl="small" /> : '+'}
      </div>

      {error && <div className="error-box">{renderError()}</div>}
    </div>
  );
};

export default PhotoUpload;
